/**
 * variant-pre-order-message.js
 * Single-option button/radio products. Shows the selected variant's
 * data-message above the add-to-cart form and swaps the button text to
 * "Pre-Order" (reverting to the original when blank).
 *
 * NO MutationObservers — they caused an infinite mutation loop. Instead we
 * hook Dawn's variant-change events + native change, each firing a single
 * deferred write. Deferral lets Dawn finish its async button re-render first.
 * Skips the Shop Pay installments form.
 */
(function () {
  'use strict';

  var PREORDER_LABEL = 'Pre-Order';

  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    if (
      form.classList.contains('installment') ||
      form.closest('.installment') ||
      form.querySelector('shopify-payment-terms')
    ) {
      return;
    }
    setupForm(form);
  });

  function setupForm(form) {
    const scope = form.closest('section') || document;

    // Output node, once, above the form.
    let output = scope.querySelector('[data-pre-order-output]');
    if (!output) {
      output = document.createElement('div');
      output.setAttribute('data-pre-order-output', '');
      output.className = 'pre-order-message';
      output.setAttribute('role', 'status');
      form.parentNode.insertBefore(output, form);
    }

    // Cache the original button label once (string only).
    let originalBtnText = null;
    const initialSpan = getBtnSpan(form);
    if (initialSpan) originalBtnText = initialSpan.textContent.trim();

    const render = function () {
      const label = getSelectedLabel(scope);
      const message = label ? (label.dataset.message || '').trim() : '';
      console.log('[pre-order-message] msg:', JSON.stringify(message));

      output.textContent = message;
      output.style.display = message ? 'block' : 'none';

      const span = getBtnSpan(form);
      if (span && originalBtnText !== null) {
        const want = message ? PREORDER_LABEL : originalBtnText;
        if (span.textContent.trim() !== want) span.textContent = want;
      }
    };

    // Defer so Dawn's async button re-render lands BEFORE we write.
    const deferredRender = function () {
      setTimeout(render, 60);
    };

    // Native change on the picker (radios/buttons).
    scope.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"], select')) deferredRender();
    });

    // Dawn's variant-change events (covers builds that update the button via
    // an async section fetch — this fires AFTER that fetch resolves).
    scope.addEventListener('variant:change', deferredRender);       // newer Dawn / Horizon
    scope.addEventListener('on:variant:change', deferredRender);    // some builds
    document.addEventListener('variant:change', deferredRender);    // event may bubble to document

    render(); // initial paint
  }

  function getBtnSpan(form) {
    const submit = form.querySelector('.product-form__submit');
    return submit ? submit.querySelector('span') : null;
  }

  function getSelectedLabel(scope) {
    const checked = scope.querySelector('input[type="radio"]:checked');
    if (!checked) return null;

    if (checked.id) {
      const byFor = scope.querySelector(
        'label[for="' + CSS.escape(checked.id) + '"][data-message]'
      );
      if (byFor) return byFor;
    }
    const wrapping = checked.closest('label[data-message]');
    if (wrapping) return wrapping;

    const next = checked.nextElementSibling;
    if (next && next.matches('label[data-message]')) return next;

    return null;
  }
})();